import { BasicTrackingFn, EventName, EventParams, Params, SettingsProvider } from '../types';
import { mapDataVizForChartType, mapDataVizForElementType } from './utils';
import { ContextManager } from '../context/manager';
import { DataStore } from '../data/store';
import {
  getAppliedFilters,
  getDataAvailability,
  getMetadataTrackingParams,
  getTopSelectors,
} from './trackPageElementViewed.hook';

const TABLE_TYPE = 'Table';

export const trackDataExportInitiated = (
  trackEvent: BasicTrackingFn,
  componentSettings: Params,
  componentMetadata?: SettingsProvider['metadata']
) => {
  // componentMetadata comes from the BFF and is used to override default properties
  const dataViz = getDataVizValue(componentSettings);
  const metadataTrackingName = componentMetadata?.tracking?.elementName ?? '';
  const elementType = componentMetadata?.tracking?.elementType ?? mapDataVizForElementType(dataViz);

  const eventParams: EventParams = {
    elementType,
  };
  addElementDetails(eventParams, metadataTrackingName, elementType, dataViz);
  trackEvent(EventName.DataExportInitiated, eventParams);
};

const getDataVizValue = (componentSettings: Params): string | undefined => {
  if (!componentSettings.dataViz || componentSettings.dataViz.length === 0) {
    return undefined;
  }
  return componentSettings.dataViz[0];
};

export const trackDataExported = (
  trackEvent: BasicTrackingFn,
  componentSettings: Params,
  componentMetadata: SettingsProvider['metadata'],
  optionChosen: string[],
  trackingSourceData: DataStore
) => {
  const context = ContextManager.getInstance().get();
  const dataAvailability = getDataAvailability(trackingSourceData);
  const topSelectors = getTopSelectors(context.settings.values, context.settings.definitions);
  const appliedFilters = getAppliedFilters(context.filters);
  const metadataTrackingName = componentMetadata?.tracking?.elementName ?? '';
  const dataViz = getDataVizValue(componentSettings);
  const elementType = componentMetadata?.tracking?.elementType ?? mapDataVizForElementType(dataViz);
  const eventParams: EventParams = {
    elementType,
  };
  addElementDetails(eventParams, metadataTrackingName, elementType, dataViz);
  const metadataTrackingParams = getMetadataTrackingParams(componentMetadata, componentSettings, trackingSourceData);
  const params = {
    ...dataAvailability,
    ...topSelectors,
    ...appliedFilters,
    ...eventParams,
    ...metadataTrackingParams,
    optionChosen,
  };
  trackEvent(EventName.DataExported, params);
};

const addElementDetails = (
  eventParams: EventParams,
  metadataTrackingName: string,
  elementType: string,
  dataViz: string
) => {
  if (elementType === TABLE_TYPE) {
    eventParams.tableName = metadataTrackingName;
  } else {
    eventParams.chartType = mapDataVizForChartType(dataViz) ?? TABLE_TYPE;
    eventParams.elementName = metadataTrackingName;
  }
};
